export default (theme) => ({
  title: {
    fontSize: '22px',
    fontWeight: 400,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginBottom: 10,
  },
  subheader: {
    padding: '5px 10px',
    color: '#646262',
  },
  data: {
    width: 'fit-content',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  column: {
    width: 'fit-content',
    fontWeight: 600
  },
  table: {
    borderSpacing: '10px'
  },
  skeletonTable: {
    padding: 10
  },
  skeletonRow: {
    marginBottom: 8
  },
  defaultText: {
    height: 144,
    lineHeight: '144px',
    verticalAlign: 'middle',
    textAlign: 'center',
    fontSize: '18px'
  },
  facebookButton: {
    color: '#4267B2'
  },
  linkedInButton: {
    color: '#2867B2'
  },
  twitterButton: {
    color: '#1DA1F2'
  },
  iconButton: {
  },
  icon: {
    height: 40,
    width: 40,
  },
  skeletonIconButton: {
    display: 'inline-block',
    margin: 10
  },
  socialIconContainer: {
    textAlign: 'right',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center'
    }
  },
});
